import { z } from "zod";

import { PayCodeMeasureUnitCodelist } from "./PayCodeMeasureUnit";
import { PayCodeRateTypeCodelist } from "./PayCodeRateType";
import { PayCodeTypeCodelist } from "./PayCodeType";

export const PayCode = z
  .object({
    guid: z.string(),
    sourceGuid: z.string(),

    name: z.string(),
    measureUnit: PayCodeMeasureUnitCodelist,

    type: PayCodeTypeCodelist,
    rateType: PayCodeRateTypeCodelist,
    rateTypeValue: z.number(),
  })
  .passthrough();

export type PayCode = z.infer<typeof PayCode>;
